import React, { useState, useEffect, useRef} from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './CreativeLoader.css';
import { Navigate } from 'react-router-dom';
import audioIntro from './assets/intro.mp3';
const CreativeLoader = ({ onComplete }) => {
  const [phase, setPhase] = useState('boxes');
  const audioRef=useRef(null);
  useEffect(() => {
    audioRef.current=new Audio(audioIntro);
audioRef.current.volume=0.099;
audioRef.current.play().catch(()=>{});
    const logoTimer = setTimeout(() => setPhase('logo'), 1200);
    const exitTimer = setTimeout(() => setPhase('exit'), 2800);
    const completeTimer = setTimeout(onComplete, 3500);

    return () => {
      clearTimeout(logoTimer);
      clearTimeout(exitTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  const boxVariants = {
    hidden: (direction) => ({
      x: direction === 'left' ? '-100vw' : direction === 'right' ? '100vw' : 0,
      y: direction === 'top' ? '-100vh' : direction === 'bottom' ? '100vh' : 0,
      z: -500,
      rotateX: 720,
      rotateY: 720,
      opacity: 0,
      scale: 0,
    }),
    visible: {
      x: 0,
      y: 0,
      z: 0,
      rotateX: 0,
      rotateY: 0,
      opacity: 1,
      scale: 1,
      transition: { 
        duration: 1, 
        ease: [0.16, 1, 0.3, 1], // Custom "snap" easing
      }
    },
    exit: {
      z: 300,
      opacity: 0,
      scale: 1.5,
      filter: "blur(10px)",
      transition: { duration: 0.6, ease: "easeInOut" }
    }
  };

  return (
    <div className="loader-container">
      <AnimatePresence mode="wait">
        {phase === 'boxes' && (
          <motion.div className="box-wrapper" exit="exit">
            <motion.div 
              className="cube cube-shadow"
              custom="left"
              variants={boxVariants}
              initial="hidden"
              animate="visible"
              style={{ background: '#4f34eaff', '--glow-color': '#4f34ea88' }} 
            />
            <motion.div 
              className="cube cube-shadow"
              custom="top"
              variants={boxVariants}
              initial="hidden"
              animate="visible"
              style={{ background: '#FF007A', '--glow-color': '#FF007A88' }} 
            />
            <motion.div 
              className="cube cube-shadow"
              custom="right"
              variants={boxVariants}
              initial="hidden"
              animate="visible"
              style={{ background: '#00F0FF', '--glow-color': '#00F0FF88' }} 
            />
          </motion.div>
        )}

        {phase === 'logo' && (
          <motion.div
            key="logo-content"
            initial={{ opacity: 0, z: -100, scale: 0.9 }}
            animate={{ opacity: 1, z: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 1.1, filter: "blur(15px)" }}
            transition={{ duration: 0.8 }}
            style={{ textAlign: 'center', transformStyle: 'preserve-3d' }}
          >
            <h1 className="logo-text">
              o n e s t o p <span className="logo-dot"> . </span>2 5
            </h1>
            <motion.p 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
              className="sub-text"
            >
              THE ONLY AESTHETIC YOU NEED
            </motion.p>
          </motion.div>
        )}
      </AnimatePresence>
      <Navigate to="/"  />
    </div>
  );
};

export default CreativeLoader;
